import { set } from 'lodash';
import { mapDistances } from 'modules/home/utils';

import { myResultsService, singleVirtualService } from '../services';

import { resultStore } from '../stores';

async function reloadVirtual() {
  const page = (resultStore.virtualMeta as AnyObject)?.current_page || 1;
  const virtual = await myResultsService.loadVirtual(page);

  if (!virtual) {
    return;
  }

  resultStore.setVirtual(mapDistances(virtual.data), virtual.meta.pagination);
}

async function reloadCumulative(id: number) {
  const index = resultStore.cumulative.findIndex((el) => el.id === id);

  if (index < 0) {
    return;
  }

  const updatedDistance = await singleVirtualService.load(id);

  if (!updatedDistance) {
    return;
  }

  const list = [...resultStore.cumulative];

  set(list, [index], updatedDistance);

  resultStore.setCumulative(mapDistances(list), resultStore.cumulativeMeta || {});
}

async function reloadDistance(id: number, type: 'virtual' | 'cumulative' = 'virtual') {
  return type === 'virtual' ? reloadVirtual() : reloadCumulative(id);
}

export { reloadDistance };
